import React from 'react';
import { createRoot } from 'react-dom/client';
import Modal from './modal.js.jsx';

export default class ConfirmWithCheck extends React.Component{
  static displayName = 'ConfirmWithCheck';

  static defaultProps = {
      confirmLabel: 'OK',
      abortLabel: 'Cancel',
      parentForm: null
  };
  constructor(props) {
    super(props);
    this.state =  {
      agreeCheckbox: false,
      errorVisible: false
    };
    this.confirmRef = React.createRef();
  }
  abort = () => {
    return this.props.onCancel(this.props.parentForm);
  }

  confirm = () => {
    if (this.state.agreeCheckbox != true) {
      this.setState({errorVisible: true});
      return;
    }
    return this.props.onConfirm(this.props.parentForm);
  }

  componentDidMount() {
    if (this.confirmRef.current){
    	this.confirmRef.current.focus();
    }
  }
  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
  render() {
    var modalBody;
    if (this.props.description) {
      modalBody = (
        <div className='modal-body'>
          {this.props.description}
        </div>
      );
    }

    return (
      <Modal modalSize="large">
        <div className='modal-header'>
          <h4 className='modal-title' style={{color: "red", fontFamily: "Poppins"}}>
            {this.props.message}
          </h4>
        </div>
        {modalBody}
        <input type="checkbox" name="agreeCheckbox" style={{marginLeft: '15px', marginTop: '2px', marginRight: '5px'}} checked={this.state.agreeCheckbox} onChange={this.handleInputChange} />
        {this.props.agreement}
        <p style={{color: 'red', marginLeft: '15px', display: this.state.errorVisible? 'block' : 'none'}}>{I18n.components.automated_negotiation_action_controls.required_to_agree}</p>
        <div className='modal-footer'>
          <div className='text-right'>
            <button
              role='abort'
              type='button'
              className='btn btn-default btn-nomargin'
              onClick={this.abort}
            >
              {this.props.abortLabel}
            </button>
            {' '}
            <button
              role='confirm'
              type='button'
              className='btn btn-primary'
              ref={this.confirmRef}
              onClick={this.confirm}
            >
              {this.props.confirmLabel}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}
/*
export function confirm_with_check(message, options) {
  var cleanup, component, props, wrapper;
  if (options == null) {
    options = {};
  }
  props = $.extend({
    message: message
  }, options);
  var newNode = document.createElement('div');
  var wrapper = document.body.appendChild(newNode);
  newNode.id = "mod-id";
  const root = createRoot(newNode);
  var component = root.render(<ConfirmWithCheck {...props}/>);
  console.log(newNode);
  cleanup = function() {
    ReactDOM.unmountComponentAtNode(newNode);
    return setTimeout(function() {
      return wrapper.remove();
    });
  };
  return component.promise.always(cleanup).promise();
};*/
export function confirmWithCheck(message, options = {}) {
  return new Promise((resolve, reject) => {
    const props = { message, ...options };
    // create a temporary container
    const wrapper = document.createElement("div");
    document.body.appendChild(wrapper);
    const root = createRoot(wrapper);
    const handleResolve = (value) => {
      cleanup();
      resolve(value);
    };

    const handleReject = (error) => {
      cleanup();
      reject(error);
    };

    const cleanup = () => {
      root.unmount();
      wrapper.remove();
    };

    // Render the component
    root.render(
      <ConfirmWithCheck
        {...props}
        onConfirm={handleResolve}
        onCancel={handleReject}
      />
    );
  });
}
